import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Row } from "react-bootstrap";
import TradingPlacesViewModel from "../../../viewModels/tradingPlaces/tradingPlacesViewModel";
import { formatDisplayPhoneNumber } from "../../../utils/phoneNumberUtils";
import TradingPlaceType from "entities/tradingPlaceType";

const TradingPlaceContactView: ViewComponent<TradingPlacesViewModel> = observer(({ vm }) => (
  <div>
    {vm.place && vm.place.salespoint && vm.place.type === TradingPlaceType.Salespoint && (
      <Col>
        <Row>
          <label>
            <b>{vm.translateGeneral("contactInformation")}</b>
          </label>
        </Row>
        {vm.place.salespoint.contactPhone && (
          <Row>
            <label>{formatDisplayPhoneNumber(vm.place.salespoint.contactPhone)}</label>
          </Row>
        )}
      </Col>
    )}
  </div>
));

export default TradingPlaceContactView;
